__turbopack_context__.v({
  "card": "ProducerSliderLayout-module-scss-module__otrTsa__card",
  "drawer": "ProducerSliderLayout-module-scss-module__otrTsa__drawer",
  "electricity": "ProducerSliderLayout-module-scss-module__otrTsa__electricity",
  "energy-types": "ProducerSliderLayout-module-scss-module__otrTsa__energy-types",
  "gas": "ProducerSliderLayout-module-scss-module__otrTsa__gas",
  "open-icon": "ProducerSliderLayout-module-scss-module__otrTsa__open-icon",
  "price": "ProducerSliderLayout-module-scss-module__otrTsa__price",
  "price-container": "ProducerSliderLayout-module-scss-module__otrTsa__price-container",
  "producer": "ProducerSliderLayout-module-scss-module__otrTsa__producer",
  "producer-container": "ProducerSliderLayout-module-scss-module__otrTsa__producer-container",
  "producer-drawer": "ProducerSliderLayout-module-scss-module__otrTsa__producer-drawer",
  "product": "ProducerSliderLayout-module-scss-module__otrTsa__product",
  "thumbnail": "ProducerSliderLayout-module-scss-module__otrTsa__thumbnail",
  "warning": "ProducerSliderLayout-module-scss-module__otrTsa__warning",
  "with-price": "ProducerSliderLayout-module-scss-module__otrTsa__with-price",
});
